import './layout.scss'

import {PageData} from 'campagne/types'
import React from 'react'
import {Footer} from 'views/campagne/partials/footer'
import {Header} from 'views/campagne/partials/header'
import {CookieBanner} from '../../cookies/views/CookieBanner'
import {style} from '../../util/style'
import {EditCms} from '../../views/layout/EditCms'
import {Hero, HeroSmall} from './partials/hero'

const styles = style('layout')

export const Layout: React.FC<PageData> = ({...props}) => {
	const {
		navigation,
		is_admin,
		project_key,
		id,
		language,
		path,
		hero,
		contact,
		channel,
		pageKey,
		inspirationImages,
		defaultHero,
		thanks,
		help,
		gtmTitle,
		cookie,
		...rest
	} = props
	const homePage = path === ''
	const registerPage = pageKey === 'register_action'
	const actionPage = channel === 'action'
	const actionsPage = channel === 'actions'
	return (
		<>
			<EditCms is_admin={is_admin} project={project_key} id={id} />
			<div class={styles}>
				{navigation && (
					<Header
						menu={navigation.header}
						primary={navigation.primary}
						secondary={navigation.secondary}
					/>
				)}
				{homePage ? (
					<Hero {...hero} help={help} />
				) : (
					hero && (
						<HeroSmall
							defaultHero={defaultHero}
							inspirationImages={inspirationImages}
							registerPage={registerPage}
							actionPage={actionPage}
							actionsPage={actionsPage}
							thanks={thanks}
							help={help}
							{...hero}
						/>
					)
				)}
				<div class={styles('content')}> {props.children}</div>
				{navigation && contact && (
					<Footer {...navigation} {...navigation.footer} {...contact} />
				)}
				<CookieBanner />
			</div>
		</>
	)
}
